import { TextField } from "@mui/material"
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers"
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns"
import moment from "moment"

interface SingleDateSelectionProps {
    start : Date | null,
    setStart : Function,
    setEnd : Function,
}

const SingleDateSelect = (props : SingleDateSelectionProps) => {
    const {start,setStart, setEnd} = props;

    function handleDateChange( newValue: Date | null) {
        setStart(moment(newValue).startOf('day').toDate());
        setEnd(moment(newValue).endOf('day').toDate());
    }

    return (
        <LocalizationProvider dateAdapter={AdapterDateFns} >
            <DatePicker
                label="Date"
                value={start}
                maxDate={new Date()}
                onChange={(newValue) => {handleDateChange(newValue);}}
                renderInput={(params) => <TextField {...params} />}
            />
        </LocalizationProvider>
    )
}

export default SingleDateSelect;